import React, { forwardRef } from "react";
import HeadingSection from "../HeadingSection/HeadingSection";
import DataFetcher from "../DataFetcher/DataFetcher";
import { HashLink as Link } from "react-router-hash-link";
import { FaMagnifyingGlassArrowRight } from "react-icons/fa6";

const predefinedFilters = {
  featured: (item) => item.featured === "1",
  sales: (item) => item.propertytype === "S",
  rentals: (item) => item.propertytype === "R",
};

const Gallery = forwardRef(({ title, tagline, filter = "featured" }, ref) => {
  const imageBaseUrl = process.env.REACT_APP_IMAGE_BASE_URL;
  const API_URL = `${process.env.REACT_APP_API_BASE_URL}?op=gallery`;

  return (
    <DataFetcher url={API_URL}>
      {(data) => (
        <section className="pt-0 pb-0 white-bg" id={data.webid} ref={ref}>
          <div className="container-fluid">
            <div className="row">
              <HeadingSection title={title} tagline={tagline} />
            </div>
            <div className="row mt-50">
              <div className="portfolio-container text-center">
                <ul id="portfolio-grid" className="three-column hover-two">
                  {data.filter(predefinedFilters[filter]).map((item) => (
                    <li className="portfolio-item" key={item.webid}>
                      <div className="portfolio photo-gallery">
                        <div className="dark-overlay">
                          <h4 className="caps-white mt-50 left-red-bar-gray">
                            {item.address} -{" "}
                            {item.price
                              ? new Intl.NumberFormat("en-US", {
                                  style: "currency",
                                  currency: "USD",
                                  maximumFractionDigits: 0,
                                  minimumFractionDigits: 0,
                                }).format(item.price)
                              : ""}
                          </h4>
                        </div>
                        <img
                          src={`${imageBaseUrl}${item.webid}/large1.jpg`}
                          alt={item.webid}
                        />
                        <div className="portfolio-wrap">
                          <ul className="portfolio-details">
                            <li>
                              <Link
                                className="alpha-lightbox"
                                to={`/property/${item.webid}#top`}
                              >
                                <FaMagnifyingGlassArrowRight size={42} />
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </section>
      )}
    </DataFetcher>
  );
});

export default Gallery;
